import * as React from "react"
import { cn } from "@/lib/utils"

export interface MyPlaylistIconProps extends React.SVGProps<SVGSVGElement> {
  /**
   * Size of the icon in pixels
   * @default 18
   */
  size?: number
}

/**
 * MyPlaylist icon as SVG
 *
 * This icon represents the MyPlaylist multi-platform music streaming feature.
 * Supports Deezer, Spotify, Apple Music, YouTube Music, and Tidal.
 *
 * Story 3.4.d - Replace Spotify with MyPlaylist (Multi-Platform Music Links)
 *
 * @example
 * ```tsx
 * <MyPlaylistIcon />
 * <MyPlaylistIcon size={24} className="text-gray-700" />
 * ```
 */
export const MyPlaylistIcon = React.forwardRef<SVGSVGElement, MyPlaylistIconProps>(
  ({ size = 18, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 15 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={cn("inline-flex shrink-0", className)}
        aria-hidden="true"
        {...props}
      >
        <path
          d="M14.1,0L4,5v10.8c-.3-.1-.6-.2-1-.2-1.7,0-3,1.3-3,3s1.3,3,3,3,3-1.3,3-3V7.2l6-3v7.6c-.3,0-.6-.2-.9-.2-1.7,0-3,1.3-3,3s1.3,3,3,3,3-1.3,3-3V0Z"
          fill="currentColor"
        />
      </svg>
    )
  }
)

MyPlaylistIcon.displayName = "MyPlaylistIcon"
